<template>
  <div class="main">
    <Menu style="width: 300px; margin-top: -7px;" />
    <div class="sub-content">
      <!-- <el-scrollbar style="height: 100%"> -->
        <router-view />
      <!-- </el-scrollbar> -->
    </div>
  </div>
</template>

<script>
import Menu from '../../components/Menu'

export default {
  name: 'project',
  components: { Menu }
}
</script>

<style lang="less" scoped>
.main {
  display: flex;
  .sub-content {
    padding: 10px;
    width: calc(100% - 320px);
    height: calc(100vh - 98px);
    overflow-y: auto;
    /*控制整个滚动条*/
    &::-webkit-scrollbar {
      background-color: transparent;
      width: 6px;
      height: 10px;
      background-clip: padding-box;
    }
    &::-webkit-scrollbar-thumb {
      width: 4px;
      height: 27px;
      // background:#C1D9EE;
      background-color: rgba(144,147,153,.4);
      border-radius: 4px;
    }
  }
}
</style>
<style lang="less">
  .el-scrollbar__wrap{
    overflow-x: hidden;
  }
</style>